import { StatusEnvioExecucao } from "@/shared/enumeradores";
import axios from "./axios-handler.service";
const BASE_URL_ENVIOS_AUTOMATICOS_TOTAL_QUALITATIVO =
  "/api/EnviosAutomaticosExecucoes";

export interface EnvioAutomaticoExecucao {
  idEnvioAutomatico: number;
  consultor: Consultor;
  status: StatusEnvioExecucao;
  descricaoStatus: string;
  motivo: string | null;
  dataCriacao: string;
  dataEnvioFila: string | null;
}

export interface Consultor {
  idConsultor: number;
  nome: string;
}

export interface FiltroEnviosAutomaticosTotalQualitativo {
  idEnvioAutomatico: number | undefined;
  dataCriacao: string;
  offset: string;
  limit: string;
  order?: string;
  consultor?: string;
  statusEnvio?: StatusEnvioExecucao | null;
}

export class EnviosAutomaticosTotalQualitativoService {
  static async listarEnviosAutomaticosTotalQualitativo(
    filtro: FiltroEnviosAutomaticosTotalQualitativo
  ): Promise<EnvioAutomaticoExecucao[]> {
    const {
      idEnvioAutomatico,
      dataCriacao,
      offset,
      limit,
      order,
      consultor,
      statusEnvio,
    } = filtro;
    const response = await axios.get<EnvioAutomaticoExecucao[]>(
      `${BASE_URL_ENVIOS_AUTOMATICOS_TOTAL_QUALITATIVO}/ListarPaginadoTotalQualitativo`,
      {
        params: {
          idEnvioAutomatico,
          dataCriacao,
          offset,
          limit,
          order,
          consultor,
          statusEnvio,
        },
      }
    );
    return response.data;
  }
}
